<template>
    <div class="home">
        <div class="first">
            <div class="content">
                <div class="text">
                    <p><span class="after">九</span><span class="line"></span><span class="after">章</span><span class="line"></span><span class="after">慧</span><span class="line"></span><span class="after">盈</span></p>
                <p>
                    九章慧盈系列服务体系致力于为客户创造竞争优势，进而助力行业的发展。“九章”取自中国数学专著《九章算术》，取其中五章《方程术》《商功术》《粟米术》《方田术》《少广术》的篇名作为人人智慧系列产品的灵感来源，为人人智慧服务体系赋予了浓厚的文化底蕴。“慧盈”则是“智慧金融，共创盈利”。
                </p>
                </div>
            </div>
        </div>
        <div class="second">
            <div class="content-wrapper">
                <img src="../assets/home-back-two.jpg"
     srcset="../assets/home-back-two@2x.jpg 2x,
             ../assets/home-back-two@3x.jpg 3x" class="backback">

                <div class="fangcheng">
                    <img src="../assets/home-back-blue.png"
     srcset="../assets/home-back-blue@2x.png 2x,
             ../assets/home-back-blue@3x.png 3x" class="blue-back">
                </div>

                <div class="shanggong">
                    <img src="../assets/home-back-blue.png"
     srcset="../assets/home-back-blue@2x.png 2x,
             ../assets/home-back-blue@3x.png 3x" class="blue-back">
                </div>
                <div class="limi">
                    <img src="../assets/home-back-blue.png"
     srcset="../assets/home-back-blue@2x.png 2x,
             ../assets/home-back-blue@3x.png 3x" class="blue-back">
                </div>

                <div class="fangtian">
                    <img src="../assets/home-back-blue.png"
     srcset="../assets/home-back-blue@2x.png 2x,
             ../assets/home-back-blue@3x.png 3x" class="blue-back">
                </div>

                <div class="shaoguang">
                    <img src="../assets/home-back-blue.png"
     srcset="../assets/home-back-blue@2x.png 2x,
             ../assets/home-back-blue@3x.png 3x" class="blue-back">
                </div>

                <div class="jiuzhang">
                    <img src="../assets/home-back-blue.png"
     srcset="../assets/home-back-blue@2x.png 2x,
             ../assets/home-back-blue@3x.png 3x" class="blue-back">
                </div>

                <div class="content-text-one">
                    <p>方程者，“以御错糅正负”</p>
                    <p>
                       方程术意为矩阵，与Matrix同义，Matrix谐音幂之。方程运用数学计算解决实际问题，为古代农耕生活提供便利；Matrix金融数据平台服务体系基于大数据与人工智能技术，为客户提供丰富功能服务。 
                    </p>
                </div>
                <div class="content-text-two">
                    <p>商功者，“以御功程积实”</p>
                    <p>
                       商功术阐释立体体积算法及工程分配方法，量化丰收成果，推动生产力发展；百智作为债券风险管理BI平台，明晰债券信息，提供可视化展示，呈现立体数据。
                    </p>
                </div>
                <div class="content-text-three">
                    <p>粟米者，“以御交质变易”</p>
                    <p>
                       粟米术阐释了比例折换方法，“粟”去壳后称为“米”，以粟以米解决了谷物粮食交易问题。慧舆作为定制化舆情跟踪系统，为客户筛选并推送定制化舆情信息，舆情信息收集清洗过程就如同粟米交易，支撑机构投资者进行投资决策。
                    </p>
                </div>
                <div class="content-text-four">
                    <p>方田者，“以御田畴界域”</p>
                    <p>
                       方田术阐释了平面几何图形面积的计算方法，由长度进阶为平面，为古代农耕社会提供计量方法。千采报价小程序做为信息共享平台，打通信息不对称现状，连接点线面（个人-同业者-同业圈），为机构投资者建立同业交流渠道。
                    </p>
                </div>
                <div class="content-text-five">
                    <p>少广者，“以御积幂方圆“</p>
                    <p>
                       AI Quant意为量堂，谐音“少广”，量堂平台为投资者提供回测中的所有数据，将开发者从繁杂的边际功能中解脱出来，更加专注于有效核心策略的生产。
                    </p>
                </div>
                <div class="content-text-six">
                    <p>九章算法</p>
                    <p>
                       九章研究院命名取自《九章算术》，力求针对客户需求，提供精细化和专业化的深度定制解决方案，为新时代各大金融机构军备竞赛提供强有力支撑。
                    </p>
                </div>
             </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Home'
}
</script>

<style lang="scss">
.home{
    min-width: 1000px;
    .first{
        min-height: 680px;
        background: url("../assets/home-back-one.jpg") no-repeat center/cover;
        @media only screen and (min--moz-device-pixel-ratio: 2),

        only screen and (-o-min-device-pixel-ratio: 2/1),

        only screen and (-webkit-min-device-pixel-ratio: 2),

        only screen and (min-device-pixel-ratio: 2){
            background: url("../assets/home-back-one@2x.jpg") no-repeat center/cover;
        }

        .content{
            width: 1000px;
            margin: 0 auto;
            color: #fff;
            overflow: hidden;
            .text{
                width: 413px;
                margin-top: 253px;
                p:nth-child(1){
                    line-height: 1.5;
                    margin-bottom: 22px;
                    .after{
                        font-size: 40px;
                        font-weight: bold;
                        margin-right: 25px;
                    }
                    .line{
                        display: inline-block;
                        width: 1px;
                        height: 32px;
                        background-color: #fff;
                        margin-right: 25px;
                    }
                }
                p:nth-child(2){
                    width: 413px;
                    font-size: 14px;
                    line-height: 1.86;
                }
            }
        }
    }
    .second{
        width: 100%;
        .content-wrapper{
            position: relative;
            .backback{
                max-width: 1400px;
            }
            width: 1400px;
            margin: 0 auto;
            .content-text-one,.content-text-two,.content-text-three,.content-text-four,.content-text-five,.content-text-six{
                position: absolute;
                text-align: center;
                width: 680px;
                top: 58px;
                left: 328px;
                display: none;
                p:nth-child(1){
                    color:#064ec1;
                    font-size:20px;
                    line-height: 40px;
                }
                p:nth-child(2){
                    color: #000;
                    font-size:14px;
                    line-height: 24px;
                }
            }
            .fangcheng{
                cursor: pointer;
                position: absolute;
                top: 231px;
                left: 500px;
                width: 340px;
                height: 50px;
                .blue-back{
                    max-width: 348px;
                    margin-top: -50px;
                    display: none;
                }
                &:hover .blue-back{
                    display: inline;
                }
                &:hover ~.content-text-one{
                    display: block;
                }
            }
            .shanggong{
                cursor: pointer;
                position: absolute;
                top: 341px;
                left: 310px;
                width: 340px;
                height: 50px;
                .blue-back{
                    max-width: 348px;
                    margin-top: -50px;
                    display: none;
                }
                &:hover .blue-back{
                    display: inline;
                }
                &:hover ~.content-text-two{
                    display: block;
                }
            }
            .limi{
                cursor: pointer;
                position: absolute;
                top: 341px;
                left: 691px;
                width: 340px;
                height: 50px;
                .blue-back{
                    max-width: 348px;
                    margin-top: -50px;
                    display: none;
                }
                &:hover .blue-back{
                    display: inline;
                }
                &:hover ~.content-text-three{
                    display: block;
                }
            }
            .fangtian{
                cursor: pointer;
               position: absolute;
                top: 554px;
                left: 310px;
                width: 340px;
                height: 50px;
                .blue-back{
                    max-width: 348px;
                    margin-top: -50px;
                    display: none;
                }
                &:hover .blue-back{
                    display: inline;
                }
                &:hover ~.content-text-four{
                    display: block;
                } 
            }
            .shaoguang{
                cursor: pointer;
               position: absolute;
                top: 554px;
                left: 691px;
                width: 340px;
                height: 50px;
                .blue-back{
                    max-width: 348px;
                    margin-top: -50px;
                    display: none;
                }
                &:hover .blue-back{
                    display: inline;
                }
                &:hover ~.content-text-five{
                    display: block;
                } 
            }
            .jiuzhang{
                cursor: pointer;
                position: absolute;
                top: 664px;
                left: 500px;
                width: 340px;
                height: 50px;
                .blue-back{
                    max-width: 348px;
                    margin-top: -50px;
                    display: none;
                }
                &:hover .blue-back{
                    display: inline;
                }
                &:hover ~.content-text-six{
                    display: block;
                }
            }
        }
    }

}
</style>